import React from 'react';

import { useOpenDrawer } from 'common/hooks/drawer';
import { useLocalization } from 'common/providers/LocaleProvider';
import DrawerBody from '../Drawer/DrawerBody';

interface InfoDrawerSubscriptionState {
  headline: string;
  content: string;
}

export const useOpenInfoDrawer = ({ headline, content }: InfoDrawerSubscriptionState) => {
  const { r, t } = useLocalization();

  const openDrawer = useOpenDrawer({
    title: headline,
    withBackButton: true,
    backButtonAriaLabel: r.t('h24_drawer_back_button', {
      backTo: t('h24_variations_drawer_label'),
    }),
    content: <DrawerBody>{content}</DrawerBody>,
  });

  return openDrawer;
};
